"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanonicalUrl = exports.eventListener = void 0;

var getCanonicalUrl = function getCanonicalUrl() {
  var element = document.querySelector("link[rel='canonical']");
  return element ? element.href : null;
};

exports.getCanonicalUrl = getCanonicalUrl;

var eventListener = function eventListener(cb) {
  var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  var eventer = window[eventMethod];
  var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
  eventer(messageEvent, cb, false);
};

exports.eventListener = eventListener;